import { render } from "./AreaLegend.vue?vue&type=template&id=05a6c3ca&ts=true"
import script from "./AreaLegend.vue?vue&type=script&lang=ts"
export * from "./AreaLegend.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__